// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ----------- Выручка ----------- */
.revenue-card {
  padding: 14px 8px 6px 8px;
  position: relative;
  overflow: hidden; /* Это главное! */
  min-height: 210px;
}

.revenue-month {
  text-align: center;
  font-size: 1.07rem;
  font-weight: 600;
  color: #232137;
  border-radius: 4px;
  padding: 2px 14px 2px 8px;
  margin: 0 auto 10px;
  font-family: "Cera Pro", Arial, sans-serif;
}

.revenue-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
}

.revenue-left {
  flex: 1 1 53%;
  min-width: 145px;
}

.progress-row {
  margin-bottom: 11px;
}

.progress-row span {
  font-size: 0.98rem;
  color: #232137;
  font-weight: 500;
  display: inline-block;
  min-width: 52px;
  font-family: "Cera Pro", Arial, sans-serif;
}

.progress-row span:last-child {
  float: right;
  font-weight: 700;
}

.progress-bar {
  height: 7px;
  background: #dedede;
  border-radius: 8px;
  margin-top: 4px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  border-radius: 8px;
}

.progress-fill.plan {
  width: 33%;
  background: linear-gradient(90deg, #2c204b 70%, #fff 100%);
}

.progress-fill.fact {
  width: 60%;
  background: linear-gradient(90deg, #e72f44 40%, #762e98 100%);
}

.progress-fill.forecast {
  width: 90%;
  background: linear-gradient(90deg, #f05a63 5%, #ffe066 85%);
}

.revenue-right {
  flex: 1 1 45%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 94px;
}

.circle-chart {
  width: 94px;
  height: 94px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-chart svg {
  width: 94px;
  height: 94px;
  transform: rotate(-90deg);
}

circle.bg {
  fill: none;
  stroke: #f2f2f2;
  stroke-width: 10;
}

circle.plan {
  fill: none;
  stroke: #2c204b;
  stroke-width: 10;
  opacity: 0.2;
}

circle.fact {
  fill: none;
  stroke: url(#grad1);
  stroke-width: 10;
  opacity: 1;
}

circle.forecast {
  fill: none;
  stroke: url(#grad2);
  stroke-width: 10;
  opacity: 0.8;
}

.circle-text {
  position: absolute;
  top: 30px;
  left: 0;
  width: 94px;
  text-align: center;
  font-size: 1.35rem;
  font-weight: 700;
  color: #232137;
  background: none;
  border-radius: 7px;
  padding: 2px 0;
  z-index: 1;
  font-family: "Cera Pro", Arial, sans-serif;
}

.revenue-note {
  margin: 13px 0 3px 0;
  text-align: center;
  color: #bbb;
  font-size: 0.98rem;
}

.pagination {
  text-align: center;
  margin-top: 8px;
}

.pagination span {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #e6e6ee;
  border-radius: 50%;
  margin: 0 2px;
}

.pagination .active {
  background: #232137;
} /* ----------- Выручка ----------- */
.revenue-card {
  padding: 14px 8px 6px 8px;
  min-height: 210px;
  position: relative;
}

.revenue-month {
  text-align: center;
  font-size: 1.07rem;
  font-weight: 600;
  color: #232137;
  border-radius: 4px;
  padding: 2px 14px 2px 8px;
  margin: 0 auto 10px;
  font-family: "Cera Pro", Arial, sans-serif;
}

.revenue-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
}

.revenue-left {
  flex: 1 1 53%;
  min-width: 145px;
}

.progress-row {
  margin-bottom: 11px;
}

.progress-row span {
  font-size: 0.98rem;
  color: #232137;
  font-weight: 500;
  display: inline-block;
  min-width: 52px;
  font-family: "Cera Pro", Arial, sans-serif;
}

.progress-row span:last-child {
  float: right;
  font-weight: 700;
}

.progress-bar {
  height: 7px;
  background: #dedede;
  border-radius: 8px;
  margin-top: 4px;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  border-radius: 8px;
}

.progress-fill.plan {
  width: 33%;
  background: linear-gradient(90deg, #2c204b 70%, #fff 100%);
}

.progress-fill.fact {
  width: 60%;
  background: linear-gradient(90deg, #e72f44 40%, #762e98 100%);
}

.progress-fill.forecast {
  width: 90%;
  background: linear-gradient(90deg, #f05a63 5%, #ffe066 85%);
}

.revenue-right {
  flex: 1 1 45%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 94px;
}

.circle-chart {
  width: 94px;
  height: 94px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-chart svg {
  width: 94px;
  height: 94px;
  transform: rotate(-90deg);
}

circle.bg {
  fill: none;
  stroke: #f2f2f2;
  stroke-width: 10;
}

circle.plan {
  fill: none;
  stroke: #2c204b;
  stroke-width: 10;
  opacity: 0.2;
}

circle.fact {
  fill: none;
  stroke: url(#grad1);
  stroke-width: 10;
  opacity: 1;
}

circle.forecast {
  fill: none;
  stroke: url(#grad2);
  stroke-width: 10;
  opacity: 0.8;
}

.circle-text {
  position: absolute;
  top: 30px;
  left: 0;
  width: 94px;
  text-align: center;
  font-size: 1.35rem;
  font-weight: 700;
  color: #232137;
  background: none;
  border-radius: 7px;
  padding: 2px 0;
  z-index: 1;
  font-family: "Cera Pro", Arial, sans-serif;
}

.revenue-note {
  margin: 13px 0 3px 0;
  text-align: center;
  color: #bbb;
  font-size: 0.98rem;
}

.pagination {
  text-align: center;
  margin-top: 8px;
}

.pagination span {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #e6e6ee;
  border-radius: 50%;
  margin: 0 2px;
}

.pagination .active {
  background: #232137;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/block/Revenue/revenue.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,oCAAA;AACA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA,EAAA,iBAAA;EACA,iBAAA;AAEF;;AACA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0CAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AAEF;;AACA;EACE,aAAA;EACA,gBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,0CAAA;AAEF;;AACA;EACE,YAAA;EACA,gBAAA;AAEF;;AACA;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAEF;;AAAA;EACE,YAAA;EACA,kBAAA;AAGF;;AADA;EACE,UAAA;EACA,0DAAA;AAIF;;AAFA;EACE,UAAA;EACA,6DAAA;AAKF;;AAHA;EACE,UAAA;EACA,2DAAA;AAMF;;AAHA;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAMF;;AAHA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAMF;;AAHA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AAMF;;AAHA;EACE,UAAA;EACA,eAAA;EACA,gBAAA;AAMF;;AAJA;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAOF;;AALA;EACE,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;AAQF;;AANA;EACE,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AASF;;AANA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,0CAAA;AASF;;AANA;EACE,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AASF;;AANA;EACE,kBAAA;EACA,eAAA;AASF;;AAPA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAUF;;AARA;EACE,mBAAA;AAWF,EAVC,oCAAA;AACD;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;AAWF;;AARA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,0CAAA;AAWF;;AARA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AAWF;;AARA;EACE,aAAA;EACA,gBAAA;AAWF;;AARA;EACE,mBAAA;AAWF;;AARA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,0CAAA;AAWF;;AARA;EACE,YAAA;EACA,gBAAA;AAWF;;AARA;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAWF;;AATA;EACE,YAAA;EACA,kBAAA;AAYF;;AAVA;EACE,UAAA;EACA,0DAAA;AAaF;;AAXA;EACE,UAAA;EACA,6DAAA;AAcF;;AAZA;EACE,UAAA;EACA,2DAAA;AAeF;;AAZA;EACE,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAeF;;AAZA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAeF;;AAZA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AAeF;;AAZA;EACE,UAAA;EACA,eAAA;EACA,gBAAA;AAeF;;AAbA;EACE,UAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAgBF;;AAdA;EACE,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;AAiBF;;AAfA;EACE,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AAkBF;;AAfA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;EACA,0CAAA;AAkBF;;AAfA;EACE,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAkBF;;AAfA;EACE,kBAAA;EACA,eAAA;AAkBF;;AAhBA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAmBF;;AAjBA;EACE,mBAAA;AAoBF","sourcesContent":["/* ----------- Выручка ----------- */\r\n.revenue-card {\r\n  padding: 14px 8px 6px 8px;\r\n  position: relative;\r\n  overflow: hidden; /* Это главное! */\r\n  min-height: 210px;\r\n}\r\n\r\n.revenue-month {\r\n  text-align: center;\r\n  font-size: 1.07rem;\r\n  font-weight: 600;\r\n  color: #232137;\r\n  border-radius: 4px;\r\n  padding: 2px 14px 2px 8px;\r\n  margin: 0 auto 10px;\r\n  font-family: 'Cera Pro', Arial, sans-serif;\r\n}\r\n\r\n.revenue-content {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n}\r\n\r\n.revenue-left {\r\n  flex: 1 1 53%;\r\n  min-width: 145px;\r\n}\r\n\r\n.progress-row {\r\n  margin-bottom: 11px;\r\n}\r\n\r\n.progress-row span {\r\n  font-size: 0.98rem;\r\n  color: #232137;\r\n  font-weight: 500;\r\n  display: inline-block;\r\n  min-width: 52px;\r\n  font-family: 'Cera Pro', Arial, sans-serif;\r\n}\r\n\r\n.progress-row span:last-child {\r\n  float: right;\r\n  font-weight: 700;\r\n}\r\n\r\n.progress-bar {\r\n  height: 7px;\r\n  background: #dedede;\r\n  border-radius: 8px;\r\n  margin-top: 4px;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n.progress-fill {\r\n  height: 100%;\r\n  border-radius: 8px;\r\n}\r\n.progress-fill.plan {\r\n  width: 33%;\r\n  background: linear-gradient(90deg, #2c204b 70%, #fff 100%);\r\n}\r\n.progress-fill.fact {\r\n  width: 60%;\r\n  background: linear-gradient(90deg, #e72f44 40%, #762e98 100%);\r\n}\r\n.progress-fill.forecast {\r\n  width: 90%;\r\n  background: linear-gradient(90deg, #f05a63 5%, #ffe066 85%);\r\n}\r\n\r\n.revenue-right {\r\n  flex: 1 1 45%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-width: 94px;\r\n}\r\n\r\n.circle-chart {\r\n  width: 94px;\r\n  height: 94px;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.circle-chart svg {\r\n  width: 94px;\r\n  height: 94px;\r\n  transform: rotate(-90deg);\r\n}\r\n\r\ncircle.bg {\r\n  fill: none;\r\n  stroke: #f2f2f2;\r\n  stroke-width: 10;\r\n}\r\ncircle.plan {\r\n  fill: none;\r\n  stroke: #2c204b;\r\n  stroke-width: 10;\r\n  opacity: 0.2;\r\n}\r\ncircle.fact {\r\n  fill: none;\r\n  stroke: url(#grad1);\r\n  stroke-width: 10;\r\n  opacity: 1;\r\n}\r\ncircle.forecast {\r\n  fill: none;\r\n  stroke: url(#grad2);\r\n  stroke-width: 10;\r\n  opacity: 0.8;\r\n}\r\n\r\n.circle-text {\r\n  position: absolute;\r\n  top: 30px;\r\n  left: 0;\r\n  width: 94px;\r\n  text-align: center;\r\n  font-size: 1.35rem;\r\n  font-weight: 700;\r\n  color: #232137;\r\n  background: none;\r\n  border-radius: 7px;\r\n  padding: 2px 0;\r\n  z-index: 1;\r\n  font-family: 'Cera Pro', Arial, sans-serif;\r\n}\r\n\r\n.revenue-note {\r\n  margin: 13px 0 3px 0;\r\n  text-align: center;\r\n  color: #bbb;\r\n  font-size: 0.98rem;\r\n}\r\n\r\n.pagination {\r\n  text-align: center;\r\n  margin-top: 8px;\r\n}\r\n.pagination span {\r\n  display: inline-block;\r\n  width: 8px;\r\n  height: 8px;\r\n  background: #e6e6ee;\r\n  border-radius: 50%;\r\n  margin: 0 2px;\r\n}\r\n.pagination .active {\r\n  background: #232137;\r\n}/* ----------- Выручка ----------- */\r\n.revenue-card {\r\n  padding: 14px 8px 6px 8px;\r\n  min-height: 210px;\r\n  position: relative;\r\n}\r\n\r\n.revenue-month {\r\n  text-align: center;\r\n  font-size: 1.07rem;\r\n  font-weight: 600;\r\n  color: #232137;\r\n  border-radius: 4px;\r\n  padding: 2px 14px 2px 8px;\r\n  margin: 0 auto 10px;\r\n  font-family: 'Cera Pro', Arial, sans-serif;\r\n}\r\n\r\n.revenue-content {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n}\r\n\r\n.revenue-left {\r\n  flex: 1 1 53%;\r\n  min-width: 145px;\r\n}\r\n\r\n.progress-row {\r\n  margin-bottom: 11px;\r\n}\r\n\r\n.progress-row span {\r\n  font-size: 0.98rem;\r\n  color: #232137;\r\n  font-weight: 500;\r\n  display: inline-block;\r\n  min-width: 52px;\r\n  font-family: 'Cera Pro', Arial, sans-serif;\r\n}\r\n\r\n.progress-row span:last-child {\r\n  float: right;\r\n  font-weight: 700;\r\n}\r\n\r\n.progress-bar {\r\n  height: 7px;\r\n  background: #dedede;\r\n  border-radius: 8px;\r\n  margin-top: 4px;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n.progress-fill {\r\n  height: 100%;\r\n  border-radius: 8px;\r\n}\r\n.progress-fill.plan {\r\n  width: 33%;\r\n  background: linear-gradient(90deg, #2c204b 70%, #fff 100%);\r\n}\r\n.progress-fill.fact {\r\n  width: 60%;\r\n  background: linear-gradient(90deg, #e72f44 40%, #762e98 100%);\r\n}\r\n.progress-fill.forecast {\r\n  width: 90%;\r\n  background: linear-gradient(90deg, #f05a63 5%, #ffe066 85%);\r\n}\r\n\r\n.revenue-right {\r\n  flex: 1 1 45%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-width: 94px;\r\n}\r\n\r\n.circle-chart {\r\n  width: 94px;\r\n  height: 94px;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.circle-chart svg {\r\n  width: 94px;\r\n  height: 94px;\r\n  transform: rotate(-90deg);\r\n}\r\n\r\ncircle.bg {\r\n  fill: none;\r\n  stroke: #f2f2f2;\r\n  stroke-width: 10;\r\n}\r\ncircle.plan {\r\n  fill: none;\r\n  stroke: #2c204b;\r\n  stroke-width: 10;\r\n  opacity: 0.2;\r\n}\r\ncircle.fact {\r\n  fill: none;\r\n  stroke: url(#grad1);\r\n  stroke-width: 10;\r\n  opacity: 1;\r\n}\r\ncircle.forecast {\r\n  fill: none;\r\n  stroke: url(#grad2);\r\n  stroke-width: 10;\r\n  opacity: 0.8;\r\n}\r\n\r\n.circle-text {\r\n  position: absolute;\r\n  top: 30px;\r\n  left: 0;\r\n  width: 94px;\r\n  text-align: center;\r\n  font-size: 1.35rem;\r\n  font-weight: 700;\r\n  color: #232137;\r\n  background: none;\r\n  border-radius: 7px;\r\n  padding: 2px 0;\r\n  z-index: 1;\r\n  font-family: 'Cera Pro', Arial, sans-serif;\r\n}\r\n\r\n.revenue-note {\r\n  margin: 13px 0 3px 0;\r\n  text-align: center;\r\n  color: #bbb;\r\n  font-size: 0.98rem;\r\n}\r\n\r\n.pagination {\r\n  text-align: center;\r\n  margin-top: 8px;\r\n}\r\n.pagination span {\r\n  display: inline-block;\r\n  width: 8px;\r\n  height: 8px;\r\n  background: #e6e6ee;\r\n  border-radius: 50%;\r\n  margin: 0 2px;\r\n}\r\n.pagination .active {\r\n  background: #232137;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
